export let ImageKey;
(function (ImageKey) {
  ImageKey["Wordpress"] = "WORDPRESS";
  ImageKey["ShopifyEmbedded"] = "SHOPIFY_EMBEDDED";
})(ImageKey || (ImageKey = {}));